import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import './styles.css'
import Dropdown from "../Dropdown";
import { useMainContext } from "../../../contexts/MainContext";
import { useCatalogsContext } from "../../../contexts/CatalogsContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, } from '@fortawesome/free-solid-svg-icons';
import InputUploadFiles from "../InputUploadFiles";
import ModalImportLog from "../ModalImportLog";

const ModalAddImport = (props) => {
    let mainContext = useMainContext();
    let catalogs = useCatalogsContext();
    const { showModal, setShow, handlerAccept, dataImport } = props
    const [formData, setFormData] = useState({})
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [filteredInitiatives, setFilteredInitiatives] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [showImportLog, setShowImportLog] = useState(false);

    useEffect(() => {
        if (!searchText.trim()) {
            setFilteredInitiatives([]);
            setShowTable(false);
            return;
        }

        const results = hardcodedInitiatives.filter(item =>
            item.name.toLowerCase().includes(searchText.toLowerCase())
        );

        setFilteredInitiatives(results);
        setShowTable(true);
    }, [searchText]);


    /**
        * Cierra el modal.
    */
    const handleClose = () => {
        setFormData({})
        setIsSubmitted(false)
        setShow(false);
    }
    const sendData = async () => {
        setIsSubmitted(true)

        if (valitation()) {

            await handlerAccept(formData)
            await setFormData({})
            setIsSubmitted(false)
        }

    }
    const valitation = () => {

        if (!formData
            || formData.initiative === undefined
            || formData.importName === undefined
            || formData.gyre === undefined
            || formData?.initiative.trim() === ""
            || formData?.importName.trim() === ""
            || formData.gyre === ""
            || formData.initiative === null
            || formData.importName === null
            || formData.gyre === null)
            return false
        else
            return true
    }

    /**
        * Comfirmacion de borrado.
    */
    useEffect(() => {
        setIsSubmitted(false)
        setFormData({})

    }, [showModal, dataImport])

    const onFormDataChange = async (name, e) => {
        setFormData({ ...formData, [name]: e.value });

    }
    // Datos quemados temporales
    const hardcodedInitiatives = [
        { id: 1, name: "La Nacional" },
        { id: 2, name: "Costalina" },
        { id: 3, name: "Naos" },
        { id: 4, name: "La Colina" },
        { id: 5, name: "Alana" },
        { id: 6, name: "Danna" },
        { id: 7, name: "Santarena" },
        { id: 8, name: "Lorena" },
    ];

    return (
        //TODO: Fix styles
        <section>
            <Modal className="cardAddImport" size={"one-input-form"} show={showModal} onHide={() => { handleClose() }} backdrop="static" centered >
                <div className="custom-card">
                    {!showTable ? (
                        <div className="custom-card-header px-3 d-flex">
                            <h4 className="py-3">Importar Archivo</h4>
                        </div>
                    ) : (
                        <div className="custom-card-header px-3 d-flex">
                            <h4 className="py-3">ASIGNAR INICIATIVA A LA IMPORTACIÓN</h4>
                        </div>
                    )}

                    <div className="custom-card-body px-3">
                        <div id="contentSearchBar">
                            <div className="contentAlert">
                                <label className="">Asignar una Iniciativa</label>
                                {
                                    (isSubmitted && !formData.initiative) &&
                                    <p className="error">*Campo Iniciativa obligatorio.</p>
                                }
                            </div>
                            <div id="search">
                                <button type="submit" id="searchButton">
                                    <span className="iconSearch">
                                        <FontAwesomeIcon icon={faSearch} />
                                    </span>
                                </button>
                                {/* <input type="text" value={formData.initiative} onChange={(e) => { onFormDataChange("initiative", e.target) }} id="inputSearch" placeholder="Nombre de la iniciativa" /> */}
                                <input type="text" id="inputSearch" placeholder="Nombre de la iniciativa" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                            </div>
                            {showTable && (
                                <div className="table-container mt-3">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Iniciativa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredInitiatives.length > 0 ? (
                                                filteredInitiatives.map((item) => (
                                                    <tr
                                                        key={item.id}
                                                        onClick={() => {
                                                            onFormDataChange("initiative", { value: item.name });
                                                            setSearchText(item.name);
                                                            setShowTable(false);
                                                        }}
                                                        className="row-option"
                                                    >
                                                        <td>{item.name}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td>No se encontraron resultados</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                        {!showTable && (
                            <>
                                <div className="contentInputUploadFiles">
                                    <label className="">
                                        Seleccionar Archivo
                                    </label>
                                    <InputUploadFiles />
                                </div>
                                <div className="contentInput">
                                    <div className="contentAlert">
                                        <label className="">
                                            Nombre de la importación
                                        </label>
                                        {
                                            (isSubmitted && !formData.importName) &&
                                            <p className="error">Campo Nombre de la importación obligatorio.</p>
                                        }
                                        {/* {
                                    (isSubmitted && formData?.importName && formData?.importName.trim() == "") &&
                                    <p className="error">*No se permiten solo espacios.</p>

                                } */}
                                    </div>
                                    <input type="text" value={formData.importName} onChange={(e) => { onFormDataChange("importName", e.target) }} maxLength="300" className="form-control black-border large-input" placeholder="Nombre" />
                                </div>
                                <div className="select-filter">
                                    <div className="contentAlert">
                                        <label className="">
                                            Selecionar Giro
                                        </label>
                                        {
                                            (isSubmitted && !formData.gyre) &&
                                            <p className="error">*Campo giro obligatorio.</p>
                                        }
                                    </div>
                                    <Dropdown value={formData.gyre} options={catalogs.gyrees} onChange={(e) => { onFormDataChange("gyre", e) }} optionValue="gyreeID" optionLabel="name" className="w-100" />
                                </div>
                            </>
                        )}
                        <div
                            className="container d-flex justify-content-end mt-5">
                            <button className="btn btn-white " onClick={() => { handleClose() }}>Cancelar</button>
                            {!showTable ? (
                                <button
                                    className="btn btn-primary ml-3"
                                    onClick={() => setShowImportLog(true)}
                                >
                                    Importar
                                </button>
                            ) : (
                                <button
                                    className="btn btn-primary ml-3"
                                    onClick={() => setShowImportLog(true)}
                                >
                                    Asignar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                <ModalImportLog showModal={showImportLog} setShow={setShowImportLog} />

            </Modal>
        </section>
    )
}
export default ModalAddImport